var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9701_125758)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9701_125758",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9701_125758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3447 16H3.65533C1.64322 16 0 14.3531 0 12.3447V3.65533C0 1.64695 1.64695 0 3.65533 0H12.3447C14.3568 0 16 1.64695 16 3.65533V12.3447C16 14.3568 14.3568 16 12.3447 16Z",
    fill: "#00EE65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52641 7.99053V6.53022C7.73357 6.48259 7.94072 6.45084 8.37099 6.45084C9.80517 6.45084 10.9685 7.59371 10.9685 9.03815C10.9685 10.4826 9.80517 11.6572 8.37099 11.6572C6.93679 11.6572 5.75757 10.4826 5.75757 9.03815V2.73657H7.22363V9.05402C7.22363 9.65719 7.71764 10.1651 8.33912 10.1651C8.96059 10.1651 9.50239 9.65719 9.50239 9.05402C9.50239 8.45084 8.95964 7.98037 8.33912 7.94291C8.08335 7.92751 7.81021 7.94195 7.52641 7.99053Z",
    fill: "#002A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52637 6.26037V4.78417C7.74946 4.75244 7.98851 4.70482 8.38688 4.70482C10.7931 4.70482 12.7532 6.62546 12.7532 9.03815C12.7532 11.4508 10.7931 13.4032 8.38688 13.4032C5.98064 13.4032 4.00464 11.4667 4.00464 9.03815V2.73657H5.47071V9.05402C5.47071 10.6572 6.74553 11.9429 8.37095 11.9429C9.99635 11.9429 11.2871 10.6572 11.2871 9.05402C11.2871 7.45084 9.98042 6.18102 8.37095 6.18102C7.9885 6.18102 7.73353 6.22862 7.52637 6.26037Z",
    fill: "#002A19"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9701_125758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandMini);
export default __webpack_public_path__ + "static/media/band_mini.075dae3a9d724e1ced8658a8a430f44f.svg";
export { ForwardRef as ReactComponent };